import type {
  TagSymbolMapping,
  TagSymbolMappingCategory,
  TagSymbolMappings,
} from './converters';

export const TAG_SYMBOL_MAPPING_CATEGORY_KEYS: TagSymbolMappingCategory[] = [
  'skiptts',
  'ttsOnly',
  'lnk',
  'red',
];

const isTagSymbolMapping = (value: unknown): value is TagSymbolMapping => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const candidate = value as Partial<Record<keyof TagSymbolMapping, unknown>>;

  return (
    typeof candidate.from === 'string' &&
    typeof candidate.to === 'string' &&
    candidate.from.trim().length > 0 &&
    candidate.to.trim().length > 0
  );
};

export const sanitizeTagSymbolMappings = (
  raw: unknown
): TagSymbolMappings | undefined => {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return undefined;

  const result: TagSymbolMappings = {};

  for (const category of TAG_SYMBOL_MAPPING_CATEGORY_KEYS) {
    const rows = (raw as Record<string, unknown>)[category];
    if (!Array.isArray(rows)) continue;

    const validRows = rows
      .filter(isTagSymbolMapping)
      .map(r => ({ from: r.from, to: r.to }));

    if (validRows.length > 0) {
      result[category] = validRows;
    }
  }

  return Object.keys(result).length > 0 ? result : undefined;
};
